import React, { useMemo } from 'react';
import { getLanguageName, listOfAllLanguages } from '../../../utilities/getListOfLanguages';
import { SelectOption } from '../../../tailwindComponents/selectTW/interfaces';
import { MultipleSelectField } from '../../../ui-toolkit';
import { FormCellTW } from '../../../tailwindComponents/formCellTW/FormCellTW';

export const LanguagesSelect: React.FC = () => {
  const languageOptions: SelectOption[] = useMemo(
    () =>
      listOfAllLanguages.map((lang: string) => ({
        label: getLanguageName(lang),
        value: lang,
      })),
    []
  );
  return (
    <FormCellTW labelText={'Languages'}>
      <MultipleSelectField name={'languages'} options={languageOptions} isMulti />
    </FormCellTW>
  );
};
